<template>
    <div class="show-case-pos" :style="{zIndex: caseShowIndex, left:caseShowIndex < 0 ? '100%':'30%' }" v-drag id="drag">
        <div style="width: 100%;height: 40px; display: flex;flex-direction: row;align-items: center;justify-content: space-between">
            <div class="card-info-area" v-if="currentCase">
                <span>机箱号：<span style="color: RGB(56,178,253)">{{currentCase.caseNo}}</span></span>
                <span>槽位号：<span style="color: RGB(56,178,253)">{{currentCase.slotNo}}</span></span>
                <span>IP：<span style="color: RGB(56,178,253)">{{currentCase.deviceIp}}</span></span>
            </div>
            <el-button type="text" @click="hideAllPopShow"><img style="width:30px;height:30px" src="../assets/close_case.png" /></el-button>
        </div>

        <div style="width: 100%;height: 40px;margin-top: 20px;display: flex;align-items: flex-start;justify-content: flex-start">
            <span style="color: #333; font-size: 14px;">板卡位置示意动图：</span>
        </div>
        <div id="show-case-box" :style="{position: caseShowIndex < 0 ? 'fixed':'relative', left: caseShowIndex < 0 ? '100%':'0'}">
            <div v-if="threeLoading"
                 class="show-case-loading">
                <div id="showLoading"></div>
            </div>
            <canvas id="three"></canvas>
        </div>
    </div>
</template>

<script>
    import * as THREE from 'three'
    import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
    import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader'
    import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'

    var FPS = 30
    var renderTime = 1 / FPS
    var timeS = 0

    export default {
        name: "DeviceCase3D",
        props: {

        },
        data() {
            return {
                scene: null,
                renderer: null,
                camera: null,
                controls: null,
                animateId: null,
                caseIndex: 0,
                boardIndex: 0,
                mixer: null,
                animating: true,
                prevTime: null,
                children: [],
                animations: [],
                clock: null,
                caseShowIndex: -1,
                threeLoading: true,
                loadingDiv: null,
                currentCase: null
            }
        },
        directives: {
            drag: {
                // 指令的定义
                bind: function (el) {
                    let oDiv = el;  // 获取当前元素
                    oDiv.onmousedown = (e) => {
                        // console.log('onmousedown')
                        // 算出鼠标相对元素的位置
                        if (document.getElementById('show-case-box').contains(e.target)) {
                            // console.log("111111111111111111111")
                            return
                        }
                        let disX = e.clientX - oDiv.offsetLeft;
                        let disY = e.clientY - oDiv.offsetTop;

                        document.onmousemove = (e) => {
                            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                            let left = e.clientX - disX;
                            let top = e.clientY - disY;

                            oDiv.style.left = left + 'px';
                            oDiv.style.top = top + 'px';
                        };

                        document.onmouseup = (e) => {
                            document.onmousemove = null;
                            document.onmouseup = null;
                        }
                    }
                }
            }
        },
        watch: {

        },
        methods: {
            cleanThree() {
                cancelAnimationFrame(this.animateId)
                this.renderer.dispose()
                this.scene.clear()
                this.scene = null
                this.camera = null
                this.controls = null
                this.renderer.domElement = null
                this.renderer = null
            },
            animate() {
                if (this.controls) {
                    this.controls.update()
                } else {
                    return
                }
                this.animateId = requestAnimationFrame(this.animate)
                this.render()
                if (this.resizeRendererToDisplaySize()) {
                    if (this.renderer) {
                        const canvas = this.renderer.domElement
                        this.camera.aspect = canvas.clientWidth / canvas.clientHeight
                        this.camera.updateProjectionMatrix()
                    }
                }
            },
            initAnimationMixer() {
                let animation
                if (this.children) {
                    this.children.forEach(child => {
                        let prefix = "业务卡-";
                        if (this.caseIndex == 0) {
                            prefix += '右-' + this.boardIndex
                        } else {
                            prefix += '左-' + this.boardIndex
                        }

                        if (child.name == prefix) {
                            // console.log(child.name)
                            this.mixer = new THREE.AnimationMixer(child)
                            animation = this.mixer.clipAction(this.animations[0]).setDuration(this.animations[0].duration)
                            animation.play()
                        }
                    })
                }
            },
            resizeRendererToDisplaySize() {
                const canvas = this.renderer.domElement
                let threeBox = document.getElementById('show-case-box')

                var width = threeBox.offsetWidth
                var height = threeBox.offsetHeight
                var canvasPixelWidth = canvas.width / window.devicePixelRatio
                var canvasPixelHeight = canvas.height / window.devicePixelRatio

                const needResize = canvasPixelWidth !== width || canvasPixelHeight !== height
                if (needResize) {
                    // console.log("setSize " + width + "/" + height)
                    this.renderer.setSize(width, height)
                    // renderer.setClearColor(0xb9d3ff, 1);
                    this.renderer.setClearColor(0xEEEEEE, 0.0);
                }
                return needResize
            },
            render() {
                if (this.mixer && this.animating) {
                    const time = Date.now();
                    this.mixer.update((time - this.prevTime) * 0.001);
                    this.prevTime = time;
                }

                let t = this.clock.getDelta()
                timeS = timeS + t
                if (timeS > renderTime) {
                    timeS = 0
                    this.renderer.render(this.scene, this.camera)
                }
            },
            light() {
                // 太阳光
                const dirLight = new THREE.DirectionalLight(0xffffff, 1.9)
                //光源等位置
                dirLight.position.set(-1, 3, -3)
                //可以产生阴影
                dirLight.castShadow = true
                dirLight.shadow.mapSize = new THREE.Vector2(1024, 1024)
                this.scene.add(dirLight)

                // 环境光 -- 照亮物体
                const hemLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 2.0)
                hemLight.position.set(-1, 3, -3)
                this.scene.add(hemLight)
            },
            initThree() {
                if (!this.loadingDiv && this.threeLoading) {
                    this.loadingDiv = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0)',
                        target: document.getElementById('showLoading')
                    });
                }
                this.clock = new THREE.Clock()
                this.scene = new THREE.Scene()
                // this.scene.background = new THREE.Color('#fff')
                const canvas = document.querySelector('#three')

                // const canvas = document.getElementById('three')
                // console.log("canvas width " + canvas.width + " height " + canvas.height)
                this.renderer = new THREE.WebGLRenderer({
                    canvas,
                    antialias: true,
                    alpha: true
                })
                this.renderer.shadowMap.enabled = true;
                // renderer.setSize(canvas.width, canvas.height)
                this.camera = new THREE.PerspectiveCamera(2, window.innerWidth / window.innerHeight, 0.1, 1000)
                this.camera.position.z = -20
                this.camera.position.y = 10
                this.camera.position.x = -10

                const modelPath = '/case/case.glb'
                const gltfLoader = new GLTFLoader()
                var dracoLoader = new DRACOLoader();
                dracoLoader.setDecoderPath('/draco/gltf/');
                // dracoLoader.setDecoderPath('/examples/js/libs/draco');

                dracoLoader.setDecoderConfig({type: "js"});
                dracoLoader.preload();
                gltfLoader.setDRACOLoader(dracoLoader);

                gltfLoader.load(
                    // resource URL
                    modelPath,
                    // called when the resource is loaded
                    (gltf) => {

                        // console.log(gltf)
                        this.children = gltf.scene.children
                        this.animations = gltf.animations
                        this.initAnimationMixer()

                        //让模型等每个部分都能产生阴影
                        gltf.scene.traverse((o) => {
                            if (o.isMesh) {
                                o.castShadow = true
                                o.receiveShadow = true
                            }
                        })
                        if (this.scene) {
                            this.scene.add(gltf.scene)
                            this.scene.scale.set(1.5, 1.5, 1.5) //缩放大小
                        }

                        // console.log("initThree done")
                        if (this.loadingDiv) {
                            this.loadingDiv.close()
                            this.loadingDiv = null
                        }
                        this.threeLoading = false
                    },
                );

                this.controls = new OrbitControls(this.camera, this.renderer.domElement)
                this.controls.enableDamping = true

                document.addEventListener('keyup', this.onKeyUp);
                this.prevTime = Date.now();
                this.light()

            },
            onKeyUp(e) {
                if (e.code == 'Space' && this.animating) {
                    this.animating = false
                }
                else if (e.code == 'Space' && !this.animating) {
                    this.prevTime = Date.now();
                    this.animating = true
                }
            },
            showCasePos(row) {
                // console.log("showCasePos ")
                // console.log(row)
                if (this.currentCase) {
                    if (this.currentCase.deviceIp == row.deviceIp) {
                        return
                    }
                    if (this.animateId) {
                        cancelAnimationFrame(this.animateId)
                    }
                    if (this.renderer) {
                        this.renderer.dispose()
                    }

                    if (this.mixer) {
                        this.mixer.stopAllAction()
                    }
                }
                this.currentCase = JSON.parse(JSON.stringify(row))
                let caseNo = row.caseNo
                let slotNo = row.slotNo
                console.log("caseNo " + caseNo + "， slotNo is " + slotNo)

                this.boardIndex = slotNo.split(".")[0]
                if (this.boardIndex > 19) {
                    this.boardIndex = 0
                }
                if (parseInt(caseNo) % 2 == 0) {
                    this.caseIndex = 0
                } else {
                    this.caseIndex = 1
                }
                this.initAnimationMixer()
                this.caseShowIndex = 999
                this.animate()
            },
            hideAllPopShow() {
                // console.log("hideAllPopShow")
                this.caseShowIndex = -1
                cancelAnimationFrame(this.animateId)
            },
        },
        beforeCreate() {

        },
        mounted() {
            this.$nextTick(() => {
                this.initThree()
            })
        },
        destroyed() {
            this.cleanThree()
        }
    };
</script>

<style lang="less">
    .show-case-pos {
        position: absolute;
        width: 60%;
        height: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #f8f8f8;
        border: 1px solid #aaa;
        border-radius: 5px;
        padding: 15px;
        .card-info-area {
            height: 100%;
            width: 80%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;

            span {
                /*margin-left: 10px;*/
                margin-right: 60px;
                color: #333;
                font-size: 14px;
            }
        }
    }

    #show-case-box {
        position: relative;
        width: 100%;
        height: 90%;
        border: 1px solid #eee;
        background-color: white;
        display: flex;
        flex-direction: row;
        /*background-color: red;*/
    }

    .show-case-loading {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    #three {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    #showLoading {
        width: 100%;
        height: 100%;
    }
</style>